import { Button } from '@/components/common/Button';
import { DialogWrapper } from '@/components/common/DialogWrapper';
import { Input } from '@/components/common/Input';
import { useFormik } from 'formik';
import { z } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';

interface BenefitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: { text: string }) => void;
  isPending?: boolean;
}

const validationSchema = z.object({
  text: z.string().min(1, 'Text is required'),
});

export const BenefitDialog = ({
  open,
  onOpenChange,
  onSubmit,
  isPending,
}: BenefitDialogProps) => {
  const formik = useFormik({
    initialValues: {
      text: '',
    },
    validationSchema: toFormikValidationSchema(validationSchema),
    onSubmit: (values) => {
      onSubmit(values);
      formik.resetForm();
    },
  });

  return (
    <DialogWrapper
      open={open}
      onOpenChange={onOpenChange}
      title="Create New Benefit"
      maxWidth="md"
    >
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-6">
        <Input
          id="text"
          name="text"
          label="Benefit Text"
          value={formik.values.text}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.text}
          touched={formik.touched.text}
          className="bg-white"
        />

        <Button
          type="submit"
          variant="primary"
          size="md"
          className="w-48"
          disabled={isPending}
        >
          {isPending ? 'Creating...' : 'Create Benefit'}
        </Button>
      </form>
    </DialogWrapper>
  );
};
